export default __webpack_public_path__ + "static/media/ic_gmx_custom.23af1bf4.svg";